/**
 * File: HomeHeader.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.1.0
 * Created: 2025-07-29
 * Last Updated: 2026-02-13
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useLayoutEffect, useState } from "react";

// Local project files
import HomeNavigation from "../navigation/HomeNavigation";
import Logo from "../ui/Logo";
import MobileNavigation from "../navigation/MobileNavigation";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function HomeHeader() {
    const [uiWidth, setUiWidth] = useState(() => window.innerWidth);

    useLayoutEffect(() => {
        const handleResize = () => setUiWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            <div className="home-header">
                <Logo isLink={true} />
                <div className="home-header__navigation">
                    {uiWidth > 600 ? (
                        <>
                            <HomeNavigation />
                        </>
                    ) : (
                        <MobileNavigation />
                    )}
                </div>
            </div>
        </>
    );
}

export default HomeHeader;
